/*
 * PDP hero — gallery carousel
 * Cycles the stage image via prev/next arrows and dot pagination.
 * Reads image URLs from the #galleryStage[data-gallery-images] attribute
 * (pipe-delimited list), set in sections/family-bundle-offer.liquid and
 * sections/bsb-55-hero.liquid.
 */
(function () {
  'use strict';

  const stageEl = document.getElementById('galleryStage');
  const mainImg = document.getElementById('galleryMainImg');
  const prevBtn = document.getElementById('galleryPrev');
  const nextBtn = document.getElementById('galleryNext');
  const dotsEl  = document.getElementById('galleryDots');
  if (!stageEl || !mainImg || !stageEl.dataset.galleryImages) return;

  const images = stageEl.dataset.galleryImages.split('|').filter(Boolean);
  const dots   = dotsEl ? Array.prototype.slice.call(dotsEl.querySelectorAll('.pdp-hero__dot')) : [];
  let activeIndex = 0;

  function goToIndex(index) {
    if (index < 0 || index >= images.length) return;

    mainImg.classList.add('is-loading');
    mainImg.removeAttribute('srcset');
    mainImg.src = images[index];
    mainImg.onload = function () { mainImg.classList.remove('is-loading'); };

    dots.forEach(function (d) {
      d.classList.remove('is-active');
      d.setAttribute('aria-selected', 'false');
    });
    if (dots[index]) {
      dots[index].classList.add('is-active');
      dots[index].setAttribute('aria-selected', 'true');
    }

    activeIndex = index;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goToIndex((activeIndex - 1 + images.length) % images.length);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goToIndex((activeIndex + 1) % images.length);
    });
  }

  if (dotsEl) {
    dotsEl.addEventListener('click', function (e) {
      const dot = e.target.closest('.pdp-hero__dot');
      if (!dot) return;
      goToIndex(dots.indexOf(dot));
    });
  }
})();
